module.exports = __webpack_public_path__ + "static/desktop-device-link-f6c42127349d32ca089b8d7ac0b3d2d5.png";